module.exports = __webpack_public_path__ + "img/service_revenue_icon.5a462cd9.svg";